<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: false,
    default: '',
  },
})
</script>

<template>
  <div class="flex justify-between items-center">
    <div class="flex items-center gap-2">
      <slot />
      <h1
        data-test="dss-module-title"
        class="font-bold text-[20px]"
      >
        {{ title }}
        <span
          v-if="subtitle"
          class="font-normal text-dss-secondary-400"
        >{{ subtitle }}</span>
      </h1>
    </div>
  </div>
</template>
